<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <region-picker :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import RegionPicker from './RegionPicker'
import SidebarItem from './SidebarItem'

// Webpack 5 no longer exposes Sass `:export` values as a default module in
// this project. Keep the Element menu colours explicit here; the matching
// layout styles continue to use the Sass variables in variables.scss.
const sidebarVariables = Object.freeze({
  menuBg: '#2c3e50',
  menuText: '#E4E7ED',
  menuActiveText: '#ffffff'
})

export default {
  components: {
    SidebarItem,
    Logo,
    RegionPicker
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes() {
      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return sidebarVariables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
